<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/103t13K/tc-custom/9781683355281.jpg?1728851607065" alt="This image is the cover for the book Life in Movies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Life in Movies
      </h1>
      <p class="bookDescription body article font2">
        <b>“A lively memoir . . . a first-hand work of cinema history . . . the testament of a pivotal figure in American moviemaking.” —Martin Scorsese</b><br/><br/>The list of films Irwin Winkler has produced in his more-than-fifty-year career is extraordinary: <i>Rocky</i>,<i> Goodfellas</i>, <i>Raging Bull</i>, <i>De-Lovely</i>, <i>The Right Stuff</i>, <i>Creed</i>, and <i>The Irishman</i>. His films have been nominated for fifty-two Academy Awards, including five movies for Best Picture, and have won twelve.<br/><br/>In <i>A Life in Movies</i>, his charming and insightful memoir, Winkler tells the stories of his career through his many films as a producer and then as a writer and director, charting the changes in Hollywood over the past decades. Winkler started in the famous William Morris mailroom and made his first film—starring Elvis—in the last days of the old studio system. Beginning in the late 1960s, and then for decades to come, he produced a string of provocative and influential films, making him one of the most critically lauded, prolific, and commercially successful producers of his era.<br/><br/>This is an engrossing and candid book, a beguiling exploration of what it means to be a producer, including purchasing rights, developing scripts, casting actors, managing directors, editing film, and winning awards. Filled with tales of legendary and beloved films, as well as some not-so-legendary and forgotten ones, <i>A Life in Movies </i>takes readers behind the scenes and into the history of Hollywood.<br/><br/><b>“Charming and anecdote packed . . . popcorn for movie nerds.” —<i>Newsweek</i></b><br/><br/><b>“A deftly written recollection of an eventful and happy life in a precarious and, frankly, insane business; a remarkably clear-eyed look behind the scenes of moviemaking.” —Kevin Kline</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Irwin Winkler
      </h2>
      
      <p class="authorDescription body article">Irwin Winkler is an American film producer, writer, and director. He is the recipient of numerous American and international honors.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Abrams Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?051d089c